import React from 'react';
import PropTypes from 'prop-types';

import './Tag.less';


function Tag({ value, className, children, ...props }) { // eslint-disable-line
  return (
    <span className={`tag ${className}`} {...props}>
      {children}
    </span>
  );
}

Tag.propTypes = {
  value: PropTypes.string, // eslint-disable-line
  className: PropTypes.string,
  // children: PropTypes.node
};

export default Tag;



// WEBPACK FOOTER //
// ./src/components/manage/common/Tag/Tag.jsx